import { combineReducers } from 'redux'
import userReducer from './reducers/userReducer'
import SyllabusReducer from './reducers/SyllabusReducer';
import languageReducer from './reducers/languageReducer';
import SubscriptionReducer from './reducers/subscriptionReducer';
const rootReducer = combineReducers({
    userReducer : userReducer,
    SyllabusReducer : SyllabusReducer,
    languageReducer: languageReducer,
    subscriptionReducer : SubscriptionReducer,
})

export default rootReducer